"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateKey = void 0;
// eslint-disable-next-line import/prefer-default-export
var generateKey = exports.generateKey = function generateKey(pre) {
  return "".concat(pre, "_").concat(new Date().getTime());
};